import { nameSpace } from './nameSpace';
import {
  createSliceWithName as filterSlice,
  initialState,
} from 'modules/filters/reducer';
import { createSelectors } from 'modules/filters/selectors';

export const moduleName = 'filters';
export const selectstate = state => state[nameSpace][moduleName];

const filters = filterSlice(`${nameSpace}/${moduleName}`, initialState);

export const { reducer } = filters;
export const { actions } = filters;
export const selectors = createSelectors(selectstate);
